<template>
  <div class="tasks-list">
    <draggable-dynamic-table ref="userTaskListTable"
                             :columns="columnsLabel"
                             :options="options"
                             @load:more="getUserTasks()"
                             @filter:remove="setFilter($event, true)"
                             @filter:set="setFilter($event)"
                             @sort:set="setSort($event)"
                             @row:clicked="handleRowClicked($event)"
                             v-model="tableData"
    />
    <!-- insert new task prompt -->
    <custom-modal :active="insertPromptStatus"
                  :fixed-height="false"
                  @close="insertPromptStatus = false">
      <template #header>
        <div class="prompt-header w-full" :class="[!$vs.rtl ? 'rtl-only' : '']">
          <vs-row>

            <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
              <div @click="$u.click('insertTaskBtn')">
                <custom-icon icon="check-icon" color="success"/>
              </div>
            </vs-col>

            <!--            <vs-spacer/>-->

            <vs-col class="w-1/2 text-center useral-font-weight-bold text-md" style="width: unset">
              {{ $t('tasks.insert.title') }}
            </vs-col>

            <!--            <vs-spacer/>-->
            <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
              <div @click="insertPromptStatus = false">
                <custom-icon icon="circle-x-icon" color="danger"/>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </template>

      <template #content>
        <div class="prompt-content p-2">
          <template>
            <keep-alive>
              <insert-task @inserted="handleReloadTable" />
            </keep-alive>
          </template>
        </div>
      </template>
    </custom-modal>

    <!-- edit task prompt -->
    <custom-modal :active="editPromptStatus"
                  :fixed-height="false"
                  @close="editPromptStatus = false">
      <template #header>
        <div class="prompt-header w-full" :class="[!$vs.rtl ? 'rtl-only' : '']">
          <vs-row>

            <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
              <div @click="$u.click('editTaskBtn')">
                <custom-icon icon="check-icon" color="success"/>
              </div>
            </vs-col>

            <!--            <vs-spacer/>-->

            <vs-col class="w-1/2 text-center useral-font-weight-bold text-md" style="width: unset">
              {{ $t('tasks.edit.title') }}
            </vs-col>

            <!--            <vs-spacer/>-->
            <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
              <div @click="editPromptStatus = false">
                <custom-icon icon="circle-x-icon" color="danger"/>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </template>

      <template #content>
        <div class="prompt-content p-2">
          <template>
            <keep-alive>
              <edit-task :task-id="selectedTask.id" @edited="handleReloadTable" />
            </keep-alive>
          </template>
        </div>
      </template>
    </custom-modal>

    <!-- accept task prompt -->
    <custom-modal :active="acceptPromptStatus"
                  :fixed-height="false"
                  @close="acceptPromptStatus = false">
      <template #header>
        <div class="prompt-header w-full" :class="[!$vs.rtl ? 'rtl-only' : '']">
          <vs-row>

            <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
              <div @click="$u.click('acceptTaskBtn')">
                <custom-icon icon="check-icon" color="success"/>
              </div>
            </vs-col>

            <!--            <vs-spacer/>-->

            <vs-col class="w-1/2 text-center useral-font-weight-bold text-md" style="width: unset">
              {{ $t('tasks.accept.title') }}
            </vs-col>

            <!--            <vs-spacer/>-->
            <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
              <div @click="acceptPromptStatus = false">
                <custom-icon icon="circle-x-icon" color="danger"/>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </template>

      <template #content>
        <div class="prompt-content p-2">
          <template>
            <keep-alive>
              <accept-task :task-id="selectedTask.id" @edited="handleReloadTable" />
            </keep-alive>
          </template>
        </div>
      </template>
    </custom-modal>

    <button id="insertNewTask" v-show="false" @click="insertPromptStatus = true"></button>
  </div>
</template>

<script>
import {getUser, getUserTasks} from '../../../http/requests/users'
import {getCategories, getTasks} from '../../../http/requests/tasks'
import DraggableDynamicTable from '../../../components/draggableDynamicTable/draggableDynamicTable.vue'
import InsertTask from '../insert/InsertTask.vue'
import Navbar from '../../../components/navbar/Navbar.vue'
import CustomModal from '@/components/modal/customModal.vue'
import CustomIcon from '@/components/icon/customIcon.vue'
import EditTask from '@/views/tasks/edit/EditTask.vue'
import AcceptTask from '@/views/tasks/accept/AcceptTask.vue'
import {getProfileTasks} from '@/http/requests/profile'

export default {
  name: 'TaskList',

  components: {
    AcceptTask,
    EditTask,
    CustomIcon,
    CustomModal,
    DraggableDynamicTable,
    InsertTask,
    Navbar
  },

  metaInfo () {
    return {
      title: `${this.user.name} ${this.user.family}`
    }
  },

  data () {
    return {
      insertPromptStatus: false,
      editPromptStatus: false,
      acceptPromptStatus: false,
      user: {
        name: '',
        family: '',
        email: '',
        total_times: ''
      },
      selectedTask: {
        id: '',
        description: '',
        startTime: '',
        endTime: '',
        category: ''
      },
      options: {
        rowKeyField: 'id'
      },
      columnsLabel: [
        {
          field: 'time',
          i18n: 'tasks.list.table.header.time',
          width: '150px',
          minWidth: 150,
          align: 'center',
          filter: true,
          type: 'search',
          filterTypes: [
            {
              icon: 'EQUAL',
              name: 'برابر باشد',
              id: 1
            },
            {
              icon: 'NOT_EQUAL',
              name: 'برابر نباشد',
              id: 2
            },
            {
              icon: 'GTE',
              name: 'بزرگتر مساوی',
              id: 3
            },
            {
              icon: 'LTE',
              name: 'کوچکتر مساوی',
              id: 4
            }
          ],
          sortable: true,
          // locked: true,
          footer: {
            textType: 'price'
          }
        },
        {
          field: 'category',
          i18n: 'tasks.list.table.header.category',
          width: 'calc((100% / 3))',
          minWidth: 200,
          align: 'center',
          filter: true,
          filterType: 'checkbox',
          filterTypes: [],
          sortable: true
          // locked: true,
          // footer: {
          //   textType: 'price'
          // }
        },
        {
          field: 'description',
          i18n: 'tasks.list.table.header.description',
          width: 'calc((100% / 3) * 2)',
          minWidth: 300,
          align: 'center',
          filter: true,
          filterType: 'search',
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              id: 1
            }
          ],
          sortable: true
          // locked: true,
          // footer: {
          //   textType: 'price'
          // }
        },
        {
          field: 'endTime',
          i18n: 'tasks.list.table.header.endTime',
          width: '140px',
          minWidth: 140,
          align: 'center',
          filter: true,
          filterType: 'date',
          filterTypes: [
            {
              icon: 'CALENDER',
              name: 'تقویم',
              id: 1
            }
          ],
          sortable: true
          // locked: true,
          // footer: {
          //   textType: 'price'
          // }
        },
        {
          field: 'startTime',
          i18n: 'tasks.list.table.header.startTime',
          width: '140px',
          minWidth: 140,
          align: 'center',
          filter: true,
          filterType: 'date',
          filterTypes: [
            {
              icon: 'CALENDER',
              name: 'تقویم',
              id: 1
            }
          ],
          sortable: true
          // locked: true,
          // footer: {
          //   textType: 'price'
          // }
        },
        {
          field: 'user',
          i18n: 'tasks.list.table.header.user',
          width: '170px',
          minWidth: 170,
          filter: true,
          filterTypes: [
            {
              icon: 'SEARCH',
              name: 'شامل شود',
              i18n: 'components.draggableDynamicTable.filter.types.search',
              id: 1
            }
          ],
          align: 'left',
          sortable: true
        },
        {
          field: 'id',
          i18n: 'tasks.list.table.header.row',
          width: '70px',
          minWidth: 70,
          align: 'center',
          autoIncrement: true,
          fixed: true,
          footer: {
            textType: 'price'
          }
        }
      ],
      loadingTimer: 0,
      tableData: [],
      filters: [],
      sorts: [],
      page: 1,
      endedList: false,
      actions: {
        toolbar: [
          {
            id: 'insertNewTask',
            icon: 'PLUS',
            iconPack: 'useral',
            color: 'success',
            permission: 'task.create'
          }
        ],
        leftToolbar: []
      }
    }
  },

  created () {
    if (this.$route.name === 'taskList' || (parseInt(this.$route.params.id) !== this.$store.state.auth.user.id && !['profileTaskList'].includes(this.$route.name))) {
      this.actions.toolbar = []
    }

    if (['profileTaskList'].includes(this.$route.name)) {
      const userIndex = this.columnsLabel.map(elm => elm.field).indexOf('user')
      if (userIndex > -1) {
        this.columnsLabel[userIndex].permission = false
      }
    }

    if (parseInt(this.$route.params.id)) {
      this.getUserInfo()
      this.getCategoriesList()
    }
    this.getUserTasks()
  },

  mounted () {
    this.$nextTick(() => {
      this.$store.dispatch('updateNavbarActions', this.actions)
      this.$store.dispatch('updateContentNavbarStyle', 'sticky')
    })
  },

  methods: {
    getUserInfo () {
      getUser(this.$route.params.id)
        .then((response) => {
          const userInfo = response.data.data
          this.user.name = userInfo.name
          this.user.family = userInfo.family
          this.user.email = userInfo.email
          this.user.total_times = userInfo.total_times

          const timeIndex = this.columnsLabel.findIndex(column => column.field === 'time')
          this.columnsLabel[timeIndex].footer.value = this.user.total_times
        })
        .catch((e) => {
          this.$vs.notify({
            time: 2500,
            title: 'پیغام',
            text: e.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    getCategoriesList () {
      const category = []
      getCategories()
        .then((response) => {
          const categories = response.data.data.children
          for (let i = 0; i < categories.length; i++) {
            if (categories[i].id > 0) {
              category.push({
                id: categories[i].id,
                value: categories[i].id ? categories[i].id : '',
                label: categories[i].name ? categories[i].name : '',
                show: false
              })
            }
          }
        })

      const category_index = this.columnsLabel.findIndex(column => column.field === 'category')
      this.columnsLabel[category_index].filterTypes = category
    },

    getUserTasks () {
      clearTimeout(this.loadingTimer)
      this.loadingTimer = setTimeout(() => {
        if (!this.endedList) {
          // this.$refs.userTaskListTable.loadMoreStatus = 'FirstLoad'
          if (this.$refs.userTaskListTable && this.tableData.length === 0) {
            this.$refs.userTaskListTable.loadMoreStatus = 'FirstLoad'
          } else if (this.$refs.userTaskListTable && this.tableData.length > 0) {
            this.$refs.userTaskListTable.loadMoreStatus = 'Loading'
          }
          let taskFunc = null
          if (this.$route.name === 'profileTaskList') {
            taskFunc = getProfileTasks(this.page, this.filters, this.sorts)
          } else if (this.$route.name === 'userTaskList') {
            taskFunc = getUserTasks(this.$route.params.id, this.page, this.filters, this.sorts)
          } else {
            taskFunc = getTasks(this.page, this.filters, this.sorts)
          }

          taskFunc.then((response) => {
            this.endedList = response.data.pagination.current_page === response.data.pagination.total_pages

            const tasks = response.data.data
            tasks.forEach((task) => {
              if (task.id > 0 &&
                  task.category.id > 0 &&
                  task.description.length > 0
              ) {
                this.tableData.push({
                  id: task.id,
                  startTime: task.started_at,
                  endTime: task.finished_at,
                  description: task.description,
                  category: task.category.name,
                  userTime: task.time,
                  acceptedTime: task.accepted_time || '',
                  time: task.accepted_time ? task.accepted_time : task.time,
                  user: {
                    id: task.user.id,
                    value: `${task.user.name} ${task.user.family}`
                  }
                })
              }
            })

            const rowIndex = this.columnsLabel.findIndex(column => column.field === 'id')
            this.columnsLabel[rowIndex].footer.value = response.data.pagination.total
            this.page = response.data.pagination.current_page + 1

            if (this.$refs.userTaskListTable) this.$refs.userTaskListTable.loadMoreStatus = ''
          })
        }
      }, 500)

    },
    setFilter (filters) {
      let filters_list = []
      const attributes = []
      Object.keys(filters).forEach((key) => {
        const categoriesId = []
        switch (key) {

        case 'id':
          if (filters[key].search !== '') filters_list.push(`id=${filters[key].search}`)
          break

        case 'startTime':
          if (filters[key].search !== '') filters_list.push(`startedAt=${filters[key].search}`)
          break

        case 'endTime':
          if (filters[key].search !== '') filters_list.push(`finishedAt=${filters[key].search}`)
          break

        case 'description':
          if (filters[key].search !== '') filters_list.push(`description=${filters[key].search}`)
          break

        case 'category':
          if (filters[key].search.length > 0) {
            for (let i = 0; i < filters[key].search.length; i++) {
              // eslint-disable-next-line no-prototype-builtins
              if (!filters[key].search[i].hasOwnProperty('show') || filters[key].search[i].show === true) {
                categoriesId.push(filters[key].search[i].id)
              }
            }
          }
          if (categoriesId.length > 0) filters_list.push(`category=${categoriesId.join('_')}`)
          break

        case 'time':
          if (filters[key].search > 0) filters_list.push(`time=${  filters[key].search}${filters[key].type.id > 1 ? `,${filters[key].type.id}` : ''}`)
          break
        }
      })
      filters_list = [filters_list, ...attributes]
      if (filters_list[0].length > 0) {
        clearTimeout(this.loadingTimer)
        setTimeout(() => {
          this.tableData = []
          this.page = 1
          this.endedList = false
          this.total_count = 0
          this.filters = filters_list
          this.getUserTasks()
        }, 400)
      }
    },
    setSort (sorts) {
      const sorts_list = []
      Object.keys(sorts).forEach((key) => {
        switch (key) {

        case 'id':
          sorts_list.push(`order[0]=id,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'startTime':
          sorts_list.push(`order[0]=started_at,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'endTime':
          sorts_list.push(`order[0]=finished_at,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'description':
          sorts_list.push(`order[0]=description,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'category':
          sorts_list.push(`order[0]=category_id,${  sorts[key] ? 'desc' : 'asc'}`)
          break

        case 'time':
          sorts_list.push(`order[0]=time,${  sorts[key] ? 'desc' : 'asc'}`)
          break
        }
      })
      if (sorts_list.length === 0) {
        sorts_list.push('order[0]=started_at,desc')
      }

      this.page = 1
      this.endedList = false
      this.tableData = []
      this.sorts = sorts_list
      this.getUserTasks()

      /*this.data = []
      this.page = 1
      this.total_count = 0
      this.sorts = sorts_list
      this.getUser()*/
    },
    handleRowClicked (row) {
      this.selectedTask = row
      if (this.$u.checkPermissions('task.update') && row.user.id === this.$store.state.auth.user.id) {
        this.editPromptStatus = true
      } else if (this.$u.checkPermissions('task.accept')) {
        this.acceptPromptStatus = true
      }
    },
    handleReloadTable () {
      this.page = 1
      this.endedList = false
      this.tableData = []
      this.getUserTasks()
      this.insertPromptStatus = false
      this.editPromptStatus = false
      this.acceptPromptStatus = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .tasks-list {
    height: 100%;
    width: 100%;
  }

  .prompt-header {
    font-size: 15px;
  }

  .prompt-content {
    overflow-y: auto;
  }

  .cursor-pointer:hover {
    cursor: pointer;
  }

  .vs-con-input-label {
    width: 100%;
  }
</style>
